import React from "react";
import { View, StyleSheet, ViewStyle, StyleProp } from "react-native";
import { radius, spacing, shadows } from "~/styles/tokens";
import { useTheme } from "~/styles/theme";

type Elevation = "flat" | "raised" | "lifted";

interface CardProps {
  children: React.ReactNode;
  elevation?: Elevation;
  style?: StyleProp<ViewStyle>;
  padding?: keyof typeof spacing;
}

export const Card: React.FC<CardProps> = ({
  children,
  elevation = "raised",
  style,
  padding = "md",
}) => {
  const { colors } = useTheme();

  const elevationStyle: ViewStyle =
    elevation === "flat"
      ? { backgroundColor: colors.background, borderColor: colors.border }
      : elevation === "lifted"
        ? {
            backgroundColor: colors.surface,
            borderColor: colors.border,
            ...shadows.md,
          }
        : {
            backgroundColor: colors.surface,
            borderColor: colors.border,
            ...shadows.sm,
          };

  return (
    <View
      style={[
        styles.base,
        { borderWidth: 1 },
        elevationStyle,
        { padding: spacing[padding] },
        style,
      ]}
    >
      {children}
    </View>
  );
};

const styles = StyleSheet.create({
  base: {
    borderRadius: radius.xl,
  },
});
